export default "__VITE_ASSET__Bmf04u0t__"